import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const RecommendationPromptVersionSchema = withDefaults({
  type: 'recommendation-prompt-version',
  fields: [
    { kind: 'attribute', name: 'mainPrompt' },
    { kind: 'attribute', name: 'validationPrompt' },
    { kind: 'attribute', name: 'modelSettings' },
    { kind: 'attribute', name: 'identity' },
    { kind: 'attribute', name: 'version' },
    { kind: 'attribute', name: 'setKey' },
    { kind: 'attribute', name: 'checksum' },
    { kind: 'attribute', name: 'status' },
    { kind: 'attribute', name: 'createdAt' },
  ],
});

export default RecommendationPromptVersionSchema;
